module.exports = __webpack_public_path__ + "img/mono-rounded.e9b17f5d.svg";